// Add an entry here for any route whose installed home-screen icon should open somewhere
// other than the base manifest's default start_url.
const ROUTE_START_URLS: Partial<Record<string, string>> = {
    courses: '/app/courses',
};

let baseManifestHref: string | null = null;
let baseManifestJson: Record<string, unknown> | null = null;
let currentBlobUrl: string | null = null;
let appliedStartUrl: string | null = null;

// The web app manifest normally has one static start_url for the whole origin. To make it
// depend on which page the user was on when they added the app to their home screen, we
// fetch the real manifest once, patch its start_url per-route, and repoint the <link
// rel="manifest"> tag at a generated blob so the browser picks up the patched copy the next
// time the user installs (native prompt or the OS's own "Add to Home Screen").
export async function syncManifestStartUrl(routeName: string | undefined): Promise<void> {
    const linkEl = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!linkEl) {
        return;
    }

    baseManifestHref ??= linkEl.getAttribute('href');
    if (!baseManifestHref) {
        return;
    }

    if (!baseManifestJson) {
        const response = await fetch(baseManifestHref);
        baseManifestJson = await response.json();
    }

    const desiredStartUrl = (routeName && ROUTE_START_URLS[routeName]) ?? (baseManifestJson!.start_url as string);
    if (desiredStartUrl === appliedStartUrl) {
        return;
    }

    const manifest = { ...baseManifestJson, start_url: desiredStartUrl };
    const blobUrl = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' }));

    linkEl.setAttribute('href', blobUrl);
    if (currentBlobUrl) {
        URL.revokeObjectURL(currentBlobUrl);
    }
    currentBlobUrl = blobUrl;
    appliedStartUrl = desiredStartUrl;
}
